<template>
	<h3 class="text-base font-medium text-gray-900">
		{{ $t("account.company_details") }}
	</h3>

	<AccountFormField
		id="company-name"
		:label="$t('account.company_name')"
		:field="validation.Name"
	>
		<template #default="{ attrs }">
			<input
				v-model="name"
				v-bind="attrs"
				name="CompanyName"
				type="text"
				autocomplete="organization"
			/>
		</template>
	</AccountFormField>

	<AccountFormField
		id="company-org-no"
		:label="$t('account.organization_number')"
		:field="validation.OrgNo"
	>
		<template #default="{ attrs }">
			<input v-model="orgNo" v-bind="attrs" name="OrgNo" type="text" />
		</template>
	</AccountFormField>

	<AccountFormField
		id="company-vat-no"
		:label="$t('account.vat_number')"
		:field="validation.VatNo"
	>
		<template #default="{ attrs }">
			<input v-model="vatNo" v-bind="attrs" name="VatNo" type="text" />
		</template>
	</AccountFormField>

	<AccountFormField
		id="company-email"
		:label="$t('account.company_email')"
		:field="validation.Email"
	>
		<template #default="{ attrs }">
			<input v-model="email" v-bind="attrs" name="CompanyEmail" type="email" />
		</template>
	</AccountFormField>

	<AccountFormField
		id="company-phone"
		:label="$t('account.company_phone')"
		:field="validation.Phone"
	>
		<template #default="{ attrs }">
			<input
				v-model="phone"
				v-bind="attrs"
				name="CompanyPhone"
				type="tel"
				autocomplete="tel"
			/>
		</template>
	</AccountFormField>
</template>

<script setup lang="ts">
import type { ValidationField } from "~/types/account";

defineProps<{
	validation: {
		Name: ValidationField;
		OrgNo: ValidationField;
		VatNo: ValidationField;
		Email: ValidationField;
		Phone: ValidationField;
	};
}>();

const name = defineModel<string>("name", { required: true });
const orgNo = defineModel<string>("orgNo", { required: true });
const vatNo = defineModel<string>("vatNo", { required: true });
const email = defineModel<string>("email", { required: true });
const phone = defineModel<string>("phone", { required: true });
</script>
